app.apply(app, {
  init: function init() {
    this.initDependencies();
  },
  initDependencies: function initDependencies() {
    this.corePlugins.init();
    this.initElementListeners('body');
  },
  initElementListeners: function initElementListeners(container) {
    app.corePlugins.initStickyHeader(container);
    app.corePlugins.initTooltips(container);
    app.corePlugins.initSelect2(container);
    app.corePlugins.initModals(container);
    app.corePlugins.initAccordion(container);
    app.corePlugins.initSmoothScroll(container);
    app.corePlugins.initCookiePolicy(container);
    app.corePlugins.initScrollTop(container);
    app.corePlugins.initDatepicker(container);
    app.corePlugins.initDateFormat(container);
    app.corePlugins.initCurrencyFormat(container);
    app.corePlugins.initNegativeCurrencyFormat(container);
    app.corePlugins.initRangeSliders(container);
    app.corePlugins.initAutoFocus(container);
    app.corePlugins.initDeviceFingerPrint(container);
    app.corePlugins.initDropdown(container);
    app.corePlugins.initOwlCarosel(container);
    app.corePlugins.initButtonSpinner(container);
    app.corePlugins.initReturnSpinner(container);
    app.area.init(container); /* Initialise area specific plugins. */
  }
});